export default "__VITE_ASSET__DgGCMwuo__"